export default "__VITE_ASSET__DxTWTKul__"